import React, { useRef, useEffect } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Reactor from 'javascripts/reactive_rails';
import { type MessageProps } from './MessageContent';

const BookmarkContent = ({ body }: MessageProps) => {
  const bookmarkId = body;
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (elementRef?.current) {
      Reactor.updateReactiveElement($(elementRef.current));
    }
  }, [elementRef]);

  useEffect(
    () => () => {
      if (elementRef.current) {
        console.log('unmount');
        elementRef.current.innerHTML = '';
      }
    },
    []
  );

  return (
    <div id='pivot-data-container'>
      <div
        id='pivot-chart-display'
        className='custom-pivot-wrapper has-col-headers has-row-headers pivot-table-font-size pivot-table-font-size--12px'
      >
        <div className='custom-pivot-inner-wrapper custom-pivot-theme-default custom-pivot-table-count'>
          <div
            ref={elementRef}
            data-reactive-path={`Publish::Bookmark-${bookmarkId}`}
            data-reactive-url={`/bookmarks/custom_pivots/${bookmarkId}.pivot_table?publishing=true`}
            data-reactive-stubbed-content='true'
            data-reactive-load-immediately='true'
            data-reactive-ignore-own-changes
            data-supports-reactive-update
            data-reactive-preserve
          >
            <aha-loading-row rows={10} column-widths='450px' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationView(BookmarkContent);
